











import { Component, Prop, Vue } from 'vue-property-decorator';
import TextInput from './_text.input.vue';
@Component({
  components: {
    'text-input': TextInput
  },
})
export default class InputAge extends Vue {
  @Prop()
  placeholder!: string;
  public label = 'Edad';
  public error = '';
  public icon= 'cake';

  onChange($text) {
      if($text.length === 0 || !(parseInt($text,10) > 0 && parseInt($text, 10) < 200)){
          this.error = 'Edad invalida';
      } else {
        this.$emit('nChange', $text)
          this.error = '';
      }
  }

}
